import React from "react";
import { useStoreDispatch } from "store/hooks";
import { fetchPaginatedApplicationsForCurrentUser } from "store/domain-data/application/application";
import { unwrapResult } from "@reduxjs/toolkit";
import { useToast } from "hooks/useToast";
import { ApplicationRecordType, IApplicationEntity } from "models/Application.model";
import { SortDirection } from "models/SortDirection.model";

export const useRecentConsentsForCurrentUser = () => {
  const dispatch = useStoreDispatch();
  const { toastError } = useToast();

  const [recentConsents, setRecentConsents] = React.useState<IApplicationEntity[]>([]);

  React.useEffect(() => {
    dispatch(
      fetchPaginatedApplicationsForCurrentUser({
        pageIndex: 1,
        pageSize: 10,
        recordType: ApplicationRecordType.Consent,
        sortDirection: SortDirection.Descending,
        isHidden: false,
      })
    )
      .then(unwrapResult)
      .then(setRecentConsents)
      .catch(toastError);
  }, [dispatch, toastError]);

  return recentConsents;
};
